export default __webpack_public_path__ + "static/media/icon-answer-money.834eb7d3.svg";